import React from 'react';
import { useParams } from 'react-router-dom';

import PanelReceptionMain from 'panels/reception/PanelReceptionMain';
import PanelDev from 'panels/dev/PanelDev';

export default function LayoutReception() {
    const { page } = useParams();

    return (
        <div className='h-screen w-full'>
            {
                (() => {
                    switch (page) {
                        case 'reception':
                            return (<PanelReceptionMain />);
                        default:
                            return (<PanelDev />);
                    }
                })()
            }
        </div>
    )
}
